module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/028-e3ab98b5ca0a663da5cee585c40a8faf.jpg";